export default __webpack_public_path__ + "assets/9f49a20d3d2bac99bd5b539397092851.jpeg";